module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter04"
    }
  }, [_vm._v("Chapter 4")])]), _c('a', {
    attrs: {
      "id": "chapter04"
    }
  }, [_c('p', {
    staticClass: "chapimage"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_vm._v("Animals")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("A")]), _vm._v("nimals are an American obsession—the horse and the pet industries generate billions of dollars every year. If you share the obsession, this chapter is for you. It introduces animal-related careers that range from the fairly conventional, such as dog grooming and training, pet sitting, and kennel and stable management, to the less common, such as animal massage, zookeeping, animal communication, and therapeutic riding instruction. These training programs prepare you to make a living with animals, whether you’re interested in teaching, beautifying, managing, handling, or healing them.")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "chapter04"
    }
  }), _c('a', {
    attrs: {
      "id": "ch4-1"
    }
  }, [_vm._v("Animal Massage "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "ch4-1"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "ch4-1"
    }
  }, [_vm._v("Animal massage, though it sounds airy-fairy, can be a very solid career. If you love animals, healing, and working with your hands, you may have found your perfect vocation. Many practitioners specialize in horse massage—a strong market, particularly in areas associated with horse farms and the horse-racing industry. Others focus on massaging house-hold ")]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("pets, helping old or ill dogs and cats feel and heal better. Although several of the programs recommend that students take additional courses in human massage, they are not required.")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("TTouch International")]), _c('br'), _vm._v("P.O. Box 3739"), _c('br'), _vm._v("Santa Fe, NM 87501"), _c('br'), _vm._v("(800) 854-8326"), _c('br'), _vm._v("(505) 455-2945"), _c('br'), _vm._v("Fax: (505) 455-7233")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("TTouch International offers a professional TTouch Practitioner training and certification program. TTouch is a hands-on technique used to improve the physical, emotional, and mental health of companion animals. The training program teaches students to identify problems and implement creative solutions using bodywork, ground exercises, and techniques for specific issues such as fear, stress, barking, biting, trauma, and recovery from surgery and accidents. Other lessons cover pain-free grooming and how to train animals with understanding and compassion. Students also learn how to market their skills to meet the growing demand for alternative animal care.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("TTouch International also offers advanced training to students who want to become TT.E.A.M. (TTouch Equine Awareness Method) Practitioners, who use TTouch techniques that encourage understanding and partnership with horses and resolve behavioral and physical difficulties. In addition to intensive workshops, the TT.E.A.M. training includes completing case studies and attending a refresher or advanced course every eighteen months.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("TTouch Practitioner—2 years (6 8-day sessions)"), _c('br'), _vm._v("TT.E.A.M. Practitioner—4 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("TTouch Practitioner—$5,000 TT.E.A.M. Practitioner—$650")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("A payment plan "), _c('em', [_vm._v("is")]), _vm._v(" available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Don Doran’s Equine Sports Massage Programs")]), _c('br'), _vm._v("14735 Southwest 71 Avenue Road"), _c('br'), _vm._v("Ocala, FL 34473"), _c('br'), _vm._v("(352) 347-3747"), _c('br'), _vm._v("Fax: (352) 347-8075")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("Don Doran offers two training programs: a professional course in Equine Sports Massage, and an Equi-Pressure practitioner course.")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The Equine Sports Massage course teaches students to apply the principles of human sports massage on horses to relieve tension and stress, increase circulation, and reduce muscle fatigue. The curriculum includes courses in equine anatomy, physiology, kinesiology, and acupressure. Students learn hands-on applications of equine sports massage, contraindications, therapeutic techniques, neuromuscular therapy, motion evaluation, stretching, pre- and postevent massage, alternative healing methods, and equine communication skills. Business skills such as networking and advertising are also taught.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Equi-Pressure course teaches equine acupressure, which is the nonintrusive stimulation of specific energy points on a horse’s body to maintain and restore vitality and health. The program trains students to use Equi-Pressure to give horses a competitive edge, stimulate good attitude, stamina, and health, locate and use the fourteen major energy channels of the horse’s body, evaluate potential problem areas, and to combine Equi-Points with magnetic therapy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Students work with many breeds of horses and a variety of equine health problems associated with racing, jumping, dressage, driving, endurance, and polo. Before attending the course, students must have a knowledge of horsemanship and feel comfortable working with horses. Although it is not a requirement of the program or the profession, Don Doran suggests that students complete a human massage training program prior to or after completion of the equine massage training.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Equine Sports Massage course—100 hours in 12 days"), _c('br'), _vm._v("Equi-Pressure course—6 days")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Equine Sports Massage Course—$ 1,395"), _c('br'), _vm._v("Equi-Pressure Course—$695")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Optissage")]), _c('br'), _vm._v("7041 Zane Trail Road"), _c('br'), _vm._v("Circleville, OH 43113"), _c('br'), _vm._v("(800) 251-0007"), _c('br'), _vm._v("(614) 474-6436"), _c('br'), _vm._v("Fax: (614) 474-2625")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("Optissage offers massage training programs for students who want to work with horses, dogs, and cats. Each of the courses covers the anatomy and physiology of the animal being studied, adapted massage techniques—including Swedish and sports massage techniques—acupressure points, massage theory, business practices, and animal behavior. The classes usually have eight or fewer students and two instructors, so each student gets personalized attention and the opportunity to perform hands-on work. For the canine and feline courses, students are encouraged to bring their own animals, although it’s not required.")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Equine program—11 days"), _c('br'), _vm._v("Canine program—6 days"), _c('br'), _vm._v("Feline program—2 days")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Equine program—$ 1,600"), _c('br'), _vm._v("Canine program—$598"), _c('br'), _vm._v("Feline program—$199")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Credit cards are accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Equissage")]), _c('br'), _vm._v("P.O. Box 447"), _c('br'), _vm._v("Round Hill, VA 20142"), _c('br'), _vm._v("(800) 843-0224"), _c('br'), _vm._v("(540) 338-1917")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Equissage offers a certification program in equine sports massage. Students learn hands-on techniques that improve circulation, relax muscle spasms, enhance muscle tone, relieve tension, and increase range of motion in high-performance horses. The program covers the application of massage techniques and strokes, the physiology of muscles, the location of major muscles and muscle groups, and specific conditions that may affect horses due to strained, pulled, tired, or sore muscles. The program is geared to meet the increasing demand of racehorse and show horse owners and trainers for equine massage services that alleviate horses’ stress and heal their sore and strained muscles.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("5 days")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$795")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Credit cards are accepted.")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('a', {
    attrs: {
      "id": "ch4-2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("Dog Training "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Most of the schools that teach dog training focus on obedience training for domestic dogs, teaching them to understand standard commands and stop unwanted behaviors. Others specialize in training police dogs, drug-sniffing dogs, or assistance dogs for the handicapped. This career could be right for you if you have a way with dogs—and, equally important, with their often less-trainable owners—and have had fun and success training your own dogs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Affection Dog Training School")]), _c('br'), _vm._v("330 East Capella Avenue"), _c('br'), _vm._v("La Habra, CA 90631"), _c('br'), _vm._v("(888) 522-6463"), _c('br'), _vm._v("(562) 697-0234")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The school offers a professional dog trainer course that emphasizes specialized techniques for different dog temperaments. Subjects covered in the course include discipline, training principles, trainer attitude, interpreting canine body language, commands such as sit, heel, sit-stay, down-stay, come, stand-stay, and retrieve, and behavioral problems such as excessive barking, destructive chewing, digging, door dashing, fence jumping, and house soiling. Other topics include advertising, conducting training sessions with clients, evaluating canine temperament and trainability, and how to sell the training program to clients.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Class time is flexible, but students who attend full-time (meeting 4 times per week) can complete the course in 5 weeks.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$2,500")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("A payment plan is available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Dog Lovers")]), _c('br'), _vm._v("5000 Crenshaw Boulevard"), _c('br'), _vm._v("Los Angeles, CA 90043"), _c('br'), _vm._v("(213) 298-8811")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("Dog Lovers offers two training courses: Obedience Dog Training and Behavior Therapy, and Obedience and Personal Protection. The ")]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("Obedience Dog Training and Behavior Therapy course trains students to correct behavior problems such as digging, barking, and jumping, and trains dogs to obey such commands as sit, stay, heel, lie down, and come. In the Obedience and Personal Protection course, students learn to train protection dogs. The program includes classes in aptitude testing, guarding, breed personality, hand signals, basic retrieving, and attacking on command.")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Obedience Dog Training and Behavior Therapy—6 months (full-time) or 12 months (part-time)"), _c('br'), _vm._v("Obedience and Personal Protection—12 months (full-time) or 24 months (part-time)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Obedience Dog Training and Behavior Therapy—$4,550"), _c('br'), _vm._v("Obedience and Personal Protection—$8,500")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Dog Lovers also offers pet-grooming courses. See Pet Grooming for information below in this chapter.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('strong', [_vm._v("National Institute of Dog Training")]), _c('br'), _vm._v("Margolis Enterprises, Inc."), _c('br'), _vm._v("11275 National Boulevard"), _c('br'), _vm._v("Los Angeles, CA 90064"), _c('br'), _vm._v("(800) 334-3647"), _c('br'), _vm._v("(310) 445-4671"), _c('br'), _vm._v("Fax: (310) 312-1832"), _c('br'), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.matthewmargolis.com",
      "target": "_blank"
    }
  }, [_vm._v("www.matthewmargolis.com")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The institute offers instruction in dog training through a two-part home-study program. "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("Part I")]), _vm._v(" teaches students to use love, praise, and affection to train dogs. They learn how to understand and communicate with dogs, and how to help families bond with them. Other subjects taught include breeds and classifications of dogs, temperament and personality testing, problem solving (including barking and housebreaking), training to heel, sit, come, and lie down, off-the-leash techniques, basic medical information, and dog nutrition. "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part02"
    }
  }, [_vm._v("Part II")]), _vm._v(" teaches the business side of dog training, including instruction in marketing, setting prices, personal selling, developing a sales plan, conducting classes that serve as a marketing tool, and creating a newsletter that boosts your business. Students also receive a complete office procedures manual, "), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("staffing suggestions, and an employee handbook. An optional in-person review and certification program is available, as is a toll-free help line.")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Correspondence course—students work at their own pace.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$1,010")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Several payment plan options are available.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('strong', [_vm._v("Pro-Train Institute")]), _c('br'), _vm._v("3131 Protea Vista"), _c('br'), _vm._v("Terrace Vista, CA 92084"), _c('br'), _vm._v("(760) 941-4241"), _c('br'), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.value-link.com/protrain.html",
      "target": "_blank"
    }
  }, [_vm._v("www.value-link.com/protrain.html")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The Pro-Train Institute offers a complete professional dog-training course. The program covers Kennel Management, Obedience Dog Training, Protection and Police Dog Training, and Service Dog Training. The Kennel Management classes cover breeding, sanitation, grooming, nutrition, whelping, and handling techniques. The Obedience Dog Training section offers instruction in dog psychology, sociology, behavior modification techniques, puppy training, and how to run a dog obedience class. The Protection and Police Dog Training sessions cover personal protection, obstacle course training, training dogs in scent discrimination, tracking and trailing procedures, and agitation techniques. And, finally, in the Service Dog Training classes, students learn how to teach dogs to lead, go around obstacles, stop at curbs, travel in a straight line, ignore distractions, and build initiative, responsibility, and appropriate disobedience.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("500 hours")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$8,000"), _c('br'), _vm._v("Cost includes room and board.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Credit cards are accepted and financing is available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("The Connecticut K-9 Education Center")]), _c('br'), _vm._v("239 Maple Hill Avenue"), _c('br'), _vm._v("Newington, CT 06111"), _c('br'), _vm._v("(203) 666-4646")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("The Connecticut K-9 Education Center offers three dog training and management courses: Kennel Management, Professional Dog Training, and Professional Guard and Attack Dog Training. The Kennel Management curriculum includes kennel design, equipment and supplies, maintaining kennel records, canine nutrition, breeding techniques, raising puppies, health and first aid, grooming, and basic obedience training. The program offers practical experience with kennel maintenance, care of pregnant bitches, laboratory procedures (such as fecal exams, mange scrapings, and heartworm checks), socializing young dogs, and handling fearful or nervous dogs.")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The Professional Dog Training course offers students hands-on experience training dogs in basic and advanced obedience, public obedience, and obstacle course training (climbing, crawling, and jumping skills). Students also learn about various types of training equipment, public relations, behavior problems, canine psychology, puppy training, and safety precautions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Professional Guard and Attack Dog Training program teaches students to train personal protection dogs, area security dogs, and guard and attack dogs. This course is only for those who have mastered basic and advanced training skills.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("How "), _c('em', [_vm._v("long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Kennel Management—10 weeks"), _c('br'), _vm._v("Professional Dog Training—14 weeks"), _c('br'), _vm._v("Professional Guard and Attack Dog Training—5 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Kennel Management—$2,850"), _c('br'), _vm._v("Professional Dog Training—$2,850"), _c('br'), _vm._v("Professional Guard and Attack Dog Training—$1,450")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Payment plans are available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Alpha Canine Professional Dog Instructor Certification")]), _c('br'), _vm._v("P.O. Box 11322"), _c('br'), _vm._v("St. Petersburg, FL 33733-1322"), _c('br'), _vm._v("(813) 319-2900"), _c('br'), _vm._v("Fax: (813) 398-0952")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("Alpha Canine offers a professional dog trainer program that covers On and Off Leash Obedience, and Behavior Modification. The On and Off ")]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Leash Obedience classes teach students how to train dogs to follow commands (such as sit-stay, down-stay, come, sit, finish, and release), how to use hand signals, and how to time praise and corrections. The Behavior Modification classes teach students to identify and treat different types of unwanted behaviors, such as aggression, phobias, obsessive/compulsive behaviors, and separation anxiety. The program also covers canine history, psychology, and health, and introduces the business skills needed to start up a dog-training business: marketing and sales strategies, record keeping, and presentation and consultation techniques.")])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("After completing the above, students may take postgraduate studies in aggression training, tricks and stunts, and assistance training for the physically impaired. Aggression training is designed to harness a dog’s aggression and use it as a weapon for protection. Tricks and stunts training prepares students to teach dogs, well, tricks and stunts, for performances in the circus, theater, or television entertainment. And the assistance training course teaches how to train canine companions for physically impaired people who need canine assistance and companionship.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("6 months")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$5,995")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Credit cards are accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Academy of Canine Education")]), _c('br'), _vm._v("75-63 185th Street"), _c('br'), _vm._v("Fresh Meadows, NY 11366"), _c('br'), _vm._v("(718) 454-5800"), _c('br'), _vm._v("Fax: (718) 264-0463")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The academy offers a certificate program in professional dog training. Students receive hands-on training. They work with a variety of breeds to learn about dog temperament and instincts, learned behavior and socialization, and basic obedience training. The course also teaches hand signals, the proper use of correction and praise, how to housebreak dogs, and how to handle chewing, barking, aggression, and shyness. Other classes include Advanced Training, Protection Training, Dog Breeds, Vaccines/Common Ailments, Nutrition, Grooming, and Kenneling. Small business topics such as writing a business plan, customer relations, and working with clients are also covered.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('em', [_vm._v("How long it takes:")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Part-time—7 to 12 weeks"), _c('br'), _vm._v("Full-time—4 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$1,995")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Payment plans are available.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('strong', [_vm._v("Canines of America")]), _c('br'), _vm._v("New York Center for Dog Training and Clinical Behavior Therapy"), _c('br'), _vm._v("89-10 Eliot Avenue"), _c('br'), _vm._v("Rego Park, NY 11374"), _c('br'), _vm._v("(718) 651-3840"), _c('br'), _vm._v("Fax: (718) 651-7681"), _c('br'), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://info@canines.com",
      "target": "_blank"
    }
  }, [_vm._v("info@canines.com")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Canines of America offers a program in Professional Dog Training. Students learn how to diagnose common behavior problems, develop treatment plans, work with clients and veterinarians, and obedience-train dogs in a humane but effective manner. Classes include Breed Identification, History of the Domestic Dog, Ethology and Behavior Modification, Learning and Development, Behavioral Pharmacology, Aggression, Phobias, and Obsessive Compulsive Behavior, Assessment, Diagnosis, and Treatment Program, Development of Dog Training Procedures and Technique, Puppy Training and Affecting Temperament Development, Instructor Skills Development, Animal Rescue, Kennel Management, Veterinary Medicine, and Developing a Training Plan.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("5 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$3,000")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Credit cards are accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Canine Behavioral Institute")]), _c('br'), _vm._v("P.O. Box 1094"), _c('br'), _vm._v("Marshalls Creek, PA 18335"), _c('br'), _vm._v("(717) 588-1277"), _c('br'), _vm._v("cbi2@ptd.net"), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.pocc.com/~cbi",
      "target": "_blank"
    }
  }, [_vm._v("www.pocc.com/~cbi")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The institute offers a vocational course in dog training. The program first focuses on the basics of dog behavior and training and then allows "), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("students to explore individual interests. The curriculum is divided into four major fields: Canidology, Canine Sociology, Training, and Business Management. Canidology covers the history of the species, character and temperament, breeding, puppy growth, and health and nutrition. Canine Sociology includes anthropomorphism, human/canine relationships, and causes of and solutions to common behavior problems. Training teaches techniques, disciplining, obedience training, and advanced training techniques—including agility, protection, tracking, and ring sport. And Business Management covers business practices, sales, marketing, advertising, financial planning, and business plan development.")])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("12 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$3,995")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("School for Professional Dog Training")]), _c('br'), _vm._v("Kromerhaus Kennel"), _c('br'), _vm._v("3247 Wimmer Road"), _c('br'), _vm._v("Bethlehem, PA 18017"), _c('br'), _vm._v("(610) 868-4009")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The school offers a program in professional dog training that covers five subjects: Training, Grooming, Kennel Management, Police Protection and Security Training, and First Aid, Health Care, and Medical Care. The Training course covers obedience training, counseling dog owners, AKC showing, and agility training. The Grooming course introduces the fundamentals of dog and cat grooming, from basic baths to clips to grooming equipment. The Kennel Management course covers day-to-day kennel operations, record keeping, pet boarding, and dealing with employees. The Police Protection and Security Training course teaches students to train dogs for law enforcement agencies, prisons, and security firms. And the First Aid, Health Care, and Medical Care course covers health care and medical concerns, first aid for dogs, and what to have in a first aid kit for dogs and kennels. Other classes discuss bookkeeping, marketing, contracts, and other small business topics.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("1 month")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$3,500")])])])])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('strong', [_vm._v("West Virginia Canine College")]), _c('br'), _vm._v("P.O. Box 2078"), _c('br'), _vm._v("Buckhannon, WV 26201"), _c('br'), _vm._v("(304) 472-6691"), _c('br'), _vm._v("Fax: (304) 472-6640")])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("West Virginia Canine College offers a program in Dog Training. The curriculum includes obedience training, protection training, tracking and scent work, business ethics and management, conformation class and show ring etiquette, anatomy, nutrition, basic veterinary care, kennel management, protection dog training, personal protection training, and advanced tracking and man trailing. It also trains students to work with dogs on obstacle courses, which is designed to give dogs self-confidence.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("12, 8, or 4 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("12 weeks—$6,000"), _c('br'), _vm._v("8 weeks—$4,200"), _c('br'), _vm._v("4 weeks—$2,100")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Payment plans and student loans are available.")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _c('a', {
    attrs: {
      "id": "ch4-3"
    }
  }, [_vm._v("Horse Management and Training")])]), _c('a', {
    attrs: {
      "id": "ch4-3"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The programs in this section teach a wide variety of skills, including stable management, riding and riding instruction, horse care and training, grooming, breeding, and even exercise riding and jockey skills. Because it doesn’t focus on a single career, we recommend that, if you’re looking for a horse-related job, you browse through all the listings. If you’re interested in equine studies career trainings that lead to degree, call or write the Harness Horse Youth Foundation at 14950 Greyhound Court, Suite 210, Carmel, IN 46032, (317) 848-5132, and ask for "), _c('em', [_vm._v("The Equine School and College Directory")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Paradise Ranch Racing School")]), _c('br'), _vm._v("10268 LaTuna Canyon Road"), _c('br'), _vm._v("Sun Valley, CA 91352"), _c('br'), _vm._v("(818) 768-8708"), _c('br'), _vm._v("Fax: (818) 252-4647")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "ch4-3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("Paradise Ranch certifies Exercise Riders/Aspiring Jockeys, Grooms, and Racing Stable Managers/Aspiring Trainers. The Exercise Rider/Aspiring Jockey course offers instruction in grooming and tacking the racehorse, mounting and dismounting, track terminology, track safety, posting and elevating, gaits, lengths of irons, seat and form, leg aids, use of weight as leverage, and use of stick. Other subjects taught include development of patience and confidence, communicating the horse’s performance to the trainer, and the rules and regulations of racing.")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The Groom training teaches students about tending and cleaning racehorses, recognizing leg problems, rubbing and bandaging, feeding and nutrition, medical treatments for lameness, understanding the body language of horses, and anatomy and conformation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Racing Stable Manager/Aspiring Trainer course offers instruction in horse care, training and conditioning, medication procedures and restrictions, horse race procedures (such as declarations and scratches and the claiming process), the client-trainer relationship, stable maintenance, and record keeping and scheduling.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Exercise Rider/Aspiring Jockey—1 to 3 months"), _c('br'), _vm._v("Groom—1 to 3 months"), _c('br'), _vm._v("Racing Stable Manager/Aspiring Trainer—1 to 3 months")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The course length depends on the student’s previous experience.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Exercise Rider/Aspiring Jockey—$1,500 per month"), _c('br'), _vm._v("Groom—$400 per month"), _c('br'), _vm._v("Racing Stable Manager/Aspiring Trainer—$400 per month")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Shasta College")]), _c('br'), _vm._v("11555 Old Oregon Trail"), _c('br'), _vm._v("P.O. Box 496006"), _c('br'), _vm._v("Redding, CA 96049"), _c('br'), _vm._v("(916) 225-4660")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("Shasta College offers a certificate program in Equine Science that prepares students for work in horse training, horse grooming and care, and stable management. Core courses include Feeds and Feeding, Horsemanship, Horse Husbandry, Western and English Riding and ")]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("Training, Veterinary Practices, Horse Training, Agriculture Practices, Environmental Resources, Horseshoeing, and Horsepacking. Students are also required to take two career-planning courses.")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("2 years")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("State residents—$550"), _c('br'), _vm._v("Nonresidents—$4,872")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Financial aid is available.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('strong', [_vm._v("College of Southern Idaho")]), _c('br'), _vm._v("Equine Program"), _c('br'), _vm._v("315 Falls Avenue"), _c('br'), _vm._v("Twin Falls, ID 83301"), _c('br'), _vm._v("(208) 733-9554, ext. 2414"), _c('br'), _vm._v("Fax: (208) 736-2136"), _c('br'), _vm._v("jknight@evergreen2.csi.cc.id.us"), _c('br'), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.csi.cc.id.us",
      "target": "_blank"
    }
  }, [_vm._v("www.csi.cc.id.us")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The college offers a certificate training program in Horse Management that combines classroom learning and hands-on work. Classes include Basic Horseshoeing, Equine Nutrition, Equine Reproduction, Horse Health, Judging Horses, Anatomy of Unsoundness, Draft Horse Management, and Beginning, Intermediate, and Advanced English and Western Riding Skills. Students are also required to take Business Aspects of Raising Horses, which offers career planning for students interested in anything from starting a horse publication to becoming a horse breeder to working as a stable manager.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("1 year")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("State residents—$1,650")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Nonresidents—$3,650")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Kentucky Horse Park")]), _c('br'), _vm._v("Education Department"), _c('br'), _vm._v("4089 Iron Works Pike"), _c('br'), _vm._v("Lexington, KY 40511"), _c('br'), _vm._v("(800) 678-8813"), _c('br'), _vm._v("(606) 259-4206"), _c('br'), _vm._v("Fax: (606) 254-0253"), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.horseworld.com/imh/kyhp/hp1.html",
      "target": "_blank"
    }
  }, [_vm._v("www.horseworld.com/imh/kyhp/hp1.html")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("The Kentucky Horse Park offers two training programs: one in Equine Management and one in Equine Training and Development. The Equine Management program includes classes in stable management, horse care, anatomy, physiology, herd health, reproduction, mare and foal care, training, and riding. But students spend only a small portion of the day in the classroom. The majority of the training is spent caring for the many different breeds of horses at the park, each of which requires individual handling, feeding, grooming, and training.")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The Equine Training and Development program is a work/study program that teaches the fundamentals of horse handling, care, and stable management. Students study and work on local farms to gain experience with different breeds of horses. Students who successfully complete the program are offered positions of employment on a Kentucky horse farm with a probationary period of six months.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Equine Management—5 months"), _c('br'), _vm._v("Equine Training and Development—3 months")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Equine Management—$ 1,000"), _c('br'), _vm._v("Equine Training and Development—$900")])])])])])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _c('a', {
    attrs: {
      "id": "ch4-4"
    }
  }, [_vm._v("Pet Grooming "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "ch4-4"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you’re interested in becoming a pet groomer, you have plenty of training options: this is by far the largest section in the Animals chapter. These schools prepare students for careers that range from entry-level assistant pet grooming to owning and managing a groom shop. In addition to regular dog grooming, many schools teach cat grooming, show grooming, pet health issues, how to set up a mobile pet-grooming business, and other special skills. If you love animals, enjoy working with your hands, and have a flair for design, comb through the following training programs. Many of the pet-grooming schools offer some affordable housing options: be sure to call for more information if necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cal-A-Hi Dog Grooming School")]), _c('br'), _vm._v("282 Camino Norte"), _c('br'), _vm._v("Chico, CA 95973"), _c('br'), _vm._v("(916) 343-1554")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "ch4-4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("Cal-A-Hi trains professional dog groomers. The program focuses on poodle, terrier, and cocker grooming, but also covers grooming of other pure and mixed breeds. The curriculum includes brushing, combing, bathing, dematting, cleaning ears, clipping nails, fluff drying, and clipping the face, feet, tail, and stomach. Courses cover such topics as dog anatomy and ear structure, first aid for dogs and groomers, pest extermination, skin disorders, handling or refusing aggressive dogs, shop design, breed styling for show dogs and pets, and tools of the trade. Some portion of each class is spent on grooming dogs for show.")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("12 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$2,200")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Payment plans are available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Beaugay’s School of Dog Grooming")]), _c('br'), _vm._v("385 First Street"), _c('br'), _vm._v("Los Altos, CA 94022"), _c('br'), _vm._v("(415) 948-4911")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Beaugay’s course offers hands-on experience grooming poodles, cockers, terriers, and mixed-breed dogs. Students learn drying techniques, shampooing, nail clipping, scissoring, dematting, undercoat raking, and finishing.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("8 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$1,700")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Dog Lovers")]), _c('br'), _vm._v("5000 Crenshaw Boulevard"), _c('br'), _vm._v("Los Angeles, CA 90043"), _c('br'), _vm._v("(213) 298-8811")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("Dog Lovers offers four grooming courses: Pet Hygienist, All Breed Dog and Cat Grooming, Pet Poodle Grooming, and Grooming and Pet Shop Management. The Pet Hygienist course includes instruction in bathing, defleaing, ear cleaning, nail clipping, dipping, tooth care, trimming, and problem dog handling. The All Breed Dog and Cat Grooming training covers breed recognition, all-breed styling, dematting, handling, brushing and trimming, nails, dipping, flea and tick control, and tooth and ")]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("ear cleaning. The Pet Poodle Grooming course covers poodle styling and care. The Grooming and Pet Shop Management course includes, in addition to grooming skills, instruction in pet health problems, customer etiquette, opening a new store, pricing, bookkeeping, sanitation, nutrition, stocking, and mobile shop setup.")])]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Pet Hygienist—6 weeks (part-time)"), _c('br'), _vm._v("All Breed Dog and Cat Grooming—6 months (full-time) or 12 months (part-time)"), _c('br'), _vm._v("Pet Poodle Grooming—6 months (full-time) or 12 months (part-time)"), _c('br'), _vm._v("Grooming and Pet Shop Management—12 months (full-time) or 24 months (part-time)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Pet Hygienist—$495"), _c('br'), _vm._v("All Breed Dog and Cat Grooming—$4,550"), _c('br'), _vm._v("Pet Poodle Grooming—$2,495"), _c('br'), _vm._v("Grooming and Pet Shop Management—$7,300")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Dog Lovers also offers dog-training courses: See Dog Training.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('strong', [_vm._v("The San Francisco SPCA Pet Grooming College")]), _c('br'), _vm._v("2500 Sixteenth Street"), _c('br'), _vm._v("San Francisco, CA 94103"), _c('br'), _vm._v("(415) 554-3000"), _c('br'), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://publicinfo@sfspca.org",
      "target": "_blank"
    }
  }, [_vm._v("publicinfo@sfspca.org")]), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.sfspca.org",
      "target": "_blank"
    }
  }, [_vm._v("www.sfspca.org")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The college offers pet-grooming training. Students work on shelter cats and dogs, learning proper bathing and grooming techniques while giving the animals a better chance at adoption. Privately owned dogs are also available, so students do learn to groom a variety of breeds. Courses include Brushing and Bathing, Eye, Ear and Foot Care, Clipper Rough Cut, Scissors Finish, Shop Procedure, Skin Care, General Health, Equipment Maintenance, and Cat Grooming. Class size is limited to six students.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("12 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$2,215")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('strong', [_vm._v("Classy Pet Grooming School")]), _c('br'), _vm._v("1542 West Eisenhower Boulevard"), _c('br'), _vm._v("Loveland, CO 80537"), _c('br'), _vm._v("(970) 667-2766")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The school offers a professional grooming program designed to train students in the basic grooming skills for all breeds of dogs and some cats. The curriculum includes selection and care of equipment, safety and sanitation, animal psychology and temperament, proper handling and restraining, anatomy and physiology, skin disorders and parasites, first aid, cat grooming, shop operation, creative grooming, and practical experience. Specific skills taught include prepping, bathing, drying, finishing, scissoring, pricing, and record keeping.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("12 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$3,400")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Credit cards are accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("The Connecticut K-9 Education Center")]), _c('br'), _vm._v("239 Maple Hill Avenue"), _c('br'), _vm._v("Newington, CT 06111"), _c('br'), _vm._v("(203) 666-4646")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The center offers a Professional Dog Grooming training course. The program includes instruction in AKC breed identification, canine psychology, shop management, safety precautions, fluff drying, ear plucking and cleaning, parasite control, poodle clips (such as the Bikini, Bolero, Dutch Cut, Lamb Cut, and Puppy Cut), terrier cuts, and clipping and styling for mixed-breed dogs.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("10 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$2,850")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Payment plans are available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Edwardian School of Dog Grooming")]), _c('br'), _vm._v("16 Cross Street"), _c('br'), _vm._v("New Canaan, CT 06840"), _c('br'), _vm._v("(203) 966-4080")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("The Edwardian School offers a Professional Dog Groomer program. Subjects include anatomy, safety, sanitation, first aid, grooming basics, ")]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("handling, brushing, combing, dematting, styling, setting patterns, bathing, drying, conditioning, grooming management, and finishing. If the school director feels that a student needs it, additional training is provided at no additional cost.")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("10 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$3,200")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("All American School of Dog Grooming")]), _c('br'), _vm._v("2607 North Pine Hills Road"), _c('br'), _vm._v("Orlando, FL 32808"), _c('br'), _vm._v("(407) 293-5339")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The All American School offers a Dog Grooming training course. The program includes classes on bathing, fluff drying, dipping, shampooing, clipper control and maintenance, grooming the face, stomach, and tush, stripping down, scissoring, setting patterns, and grooming poodle heads, feet, and teddy bear faces. Graduates are able to take a refresher course at no additional charge at any time within one year.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("10 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$1,525")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Star Academy for Pet Stylists")]), _c('br'), _vm._v("2201 Southeast Indian Street, Unit C-6"), _c('br'), _vm._v("Stuart, FL 34997"), _c('br'), _vm._v("(561) 221-9330")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Star Academy offers two levels of training: Basic All-Breed Grooming and professional master All-Breed Grooming Management.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Basic All-Breed Grooming course teaches selection and care of equipment, safety and sanitation, first aid and CPR, anatomy, pest control, handling, clipping nails, cleaning ears, brushing, bathing, drying, clipping, scissoring, finishing, and cat grooming.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Master All-Breed Grooming Management course teaches students to identify and groom every AKC breed, including advanced poodle grooming and creative grooming. Students also learn business management, retailing, boarding, and how to own and operate a professional grooming salon.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('em', [_vm._v("How long it takes:")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Basic All-Breed Grooming—11 weeks"), _c('br'), _vm._v("Master Ail-Breed Grooming—19 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Basic All-Breed Grooming—$2,825"), _c('br'), _vm._v("Master All-Breed Grooming—$4,450")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Florida School of Dog Grooming")]), _c('br'), _vm._v("2315 North A Street"), _c('br'), _vm._v("Tampa, FL 33609"), _c('br'), _vm._v("(813) 254-2213")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The Florida School of Dog Grooming trains professional dog groomers. The curriculum is divided into two sections: Grooming and Management. The Grooming courses cover basic equipment, bathing, flea dipping, cleaning ears, clipping nails, handling puppies and old dogs, poodle clipping, scissoring techniques (including styling and shaping the legs, body, topknot, mustache, and tail), caring for matted and tangled coats, and mastering pattern styling. The Management courses cover shop design, advertising, insurance, records and receipts, setting rates, bookkeeping, and boarding kennel management.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The school is also a working grooming salon, so students are able to work with customers and their pets in a professional setting. And the school also offers a refresher course at no additional charge for students who desire more training.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("12 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$2,825")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("A payment plan is available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Academy of Dog Grooming Arts")]), _c('br'), _vm._v("1900 South Arlington Heights Road"), _c('br'), _vm._v("Arlington Heights, IL 60005"), _c('br'), _vm._v("(847) 228-5700"), _c('br'), _vm._v("Fax: (847) 228-5700")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The academy offers two professional training programs: Assistant Groomer and Professional Groomer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Assistant Groomer course trains students in the selection and care of equipment, safety and sanitation, dog anatomy and physiology, handling young, old, and aggressive dogs, skin disorders, parasites, bathing, drying, fur care, and animal CPR.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("The Professional Groomer offers more advanced training in mixed breed poodle, terrier, spaniel, and long-hair breed styling, scissoring and finishing, cat grooming, and bow making. Other professional classes cover grooming the neglected pet, canine massage therapy, fluff and cage drying, and nutrition.")])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The academy also offers a Canine Cardiopulmonary Resuscitation seminar and a Shop Owner’s course for those wishing to own or manage a grooming shop.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Assistant Groomer—6 weeks"), _c('br'), _vm._v("Professional Groomer—13 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Assistant Groomer—$2,400"), _c('br'), _vm._v("Professional Groomer—$3,900")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("The Nash Academy")]), _c('br'), _vm._v("857 Lane Allen Road"), _c('br'), _vm._v("Lexington, KY 40504"), _c('br'), _vm._v("(800) 788-5301"), _c('br'), _vm._v("(606) 276-5301"), _c('br'), _vm._v("Fax: (606) 277-1977")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("725 River Road"), _c('br'), _vm._v("Edgewater, NJ 07020"), _c('br'), _vm._v("(800) 788-5301"), _c('br'), _vm._v("(201) 943-2710"), _c('br'), _vm._v("Fax: (201) 945-2721")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The Nash Academy’s two schools each offers three levels of pet grooming training. Level I teaches brushing, combing, clipping nails, cleaning ears, preparatory clipping, bathing, drying, and basic finishing techniques. Level II teaches students to properly groom the most popular breeds of dogs (including poodles, cocker spaniels, and schnauzers) and cats. Level III trains students to perfect their grooming skills, increase their speed and efficiency, and concentrate on proper breed profile. Graduates of Level III may retake any of the trainings at no additional charge. The academy also offers a Japanese exchange program—students spend one month learning Japanese dog styling while living in Japan.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('em', [_vm._v("How long it takes:")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Level I—1 month"), _c('br'), _vm._v("Level II—1 month"), _c('br'), _vm._v("Level III—1 month")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Level I—$2,975"), _c('br'), _vm._v("Level II—$1,000"), _c('br'), _vm._v("Level III—$1,000")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Payment plans and financing options are available.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('strong', [_vm._v("Pedigree Career Institute")]), _c('br'), _vm._v("Harbor Mall, Route 1A"), _c('br'), _vm._v("The Lynnway"), _c('br'), _vm._v("Lynn, MA 01901"), _c('br'), _vm._v("(800) 615-3647"), _c('br'), _vm._v("(617) 592-3647"), _c('br'), _vm._v("Fax: (617) 593-4454"), _c('br'), _vm._v("info@pedigreecareer.com"), _c('br'), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.pedigreecareer.com",
      "target": "_blank"
    }
  }, [_vm._v("www.pedigreecareer.com")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The institute’s Professional All-Breed Dog and Cat Grooming program is organized into four levels: Brushing and Bathing, Terriers and Sporting Breeds, Poodles and Non-Sporting Breeds, and Transition to Workplace. Brushing and Bathing covers the fundamentals of pet care, first-response medical procedures, muscular and skeletal anatomy, identifying specific coat textures and common skin and parasitic conditions, and selecting and applying appropriate shampoos and other products. The Terriers and Sporting Breeds course teaches breed profiles, history, origin, ancestry, coat texture, and general temperament of long- and short-legged terriers. It also offers instruction in clipping, scissoring, hand stripping, plucking, and carding. The Poodles and Non-Sporting Breeds course teaches a minimum of three poodle show trims and four poodle pet trims, grooming patterns for mixed-breed dogs, and handling and grooming cats. Specialty tools are introduced, and clipper and scissor techniques are emphasized. Transition to Workplace covers advanced grooming techniques such as drop coat scissoring, but focuses on teaching grooming shop management: starting and setting up a shop, purchasing, pricing, and selling retail items, marketing, establishing fees, using revenue-generating tie-ins, and record keeping and time management.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("The institute offers job placement assistance, and, for the grooming entrepreneur, a current list of grooming businesses for sale.")])]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("5 months")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$5,800")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Installment plans and private loans are available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Baltimore School of Dog Grooming")]), _c('br'), _vm._v("1007 West 41st Street"), _c('br'), _vm._v("Baltimore, MD 21211"), _c('br'), _vm._v("(410) 889-9070")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The school offers two training programs: a Dog Groomer’s Assistant program and a Professional All-Breed Dog Groomer program.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Dog Groomer’s Assistant program prepares students to assist professional dog groomers. Topics include bathing, ear cleaning, fluff drying, nail manicuring, coat conditioning, canine geriatrics, and sanitation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Professional All-Breed Dog Groomer program prepares students to own and operate their own business or to find employment at a grooming salon. In addition to all the courses offered in the assistant program, the professional program teaches pattern placement and styling, straight scissoring techniques, genetics and breeding, boarding kennel management, equipment maintenance, advertising, bookkeeping, shop operation, and customer relations.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Dog Groomer’s Assistant—10 weeks"), _c('br'), _vm._v("Professional All-Breed Dog Groomer—10 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Dog Groomer’s Assistant—$ 1,200"), _c('br'), _vm._v("Professional All-Breed Dog Groomer—$4,900")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Payment plans are available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Maryland School of Dog Grooming")]), _c('br'), _vm._v("8025 13th Street"), _c('br'), _vm._v("Silver Spring, MD 20910"), _c('br'), _vm._v("(800) 543-3228"), _c('br'), _vm._v("(301) 585-4311"), _c('br'), _vm._v("Fax: (301) 585-7683")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("The school offers three training programs: Poodle Grooming, All-Breed Dog Grooming, and Grooming Shop and Kennel Management. The Poodle Grooming course is the basic training, teaching clipping, brushing, combing, fluff drying, and bathing. It also teaches how to scissor a poodle—a most difficult but rewarding skill.")])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The All-Breed Dog Grooming course continues the training with classes on short-legged terriers, long-legged terriers, soft-coated terriers, Bouvier des Flandres, Old English sheepdogs, sporting dogs, long-haired dogs, short-haired dogs, and cats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Students who want to operate or manage a grooming shop or kennel take the Grooming Shop and Kennel Management course, which covers first aid, business practices, kennel design, computer knowledge, obedience training, show grooming and handling, and building a clientele. The All-Breed Dog Grooming course is a prerequisite for Grooming Shop and Kennel Management.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Poodle Grooming—7 weeks"), _c('br'), _vm._v("All-Breed Dog Grooming—14 weeks"), _c('br'), _vm._v("Grooming Shop and Kennel Management—12 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Poodle Grooming—$3,100"), _c('br'), _vm._v("All-Breed Dog Grooming—$4,150"), _c('br'), _vm._v("Grooming Shop and Kennel Management—$2,700")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Payment plans are available and credit cards are accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("The Missouri School of Dog Grooming")]), _c('br'), _vm._v("9611 Olive Boulevard"), _c('br'), _vm._v("St. Louis, MO 63132"), _c('br'), _vm._v("(314) 567-3647")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The Missouri School offers two training courses: a Groomer’s Assistant course and a Professional Career course. The Groomer’s Assistant course prepares students for employment as skin and coat technicians in a grooming shop. It teaches how to thoroughly groom over fifty dog breeds and assist a stylist in preparation of all breeds of dogs and cats.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("The Professional Career course offers students a solid foundation for owning or running a grooming business, and teaches how to groom all 138 AKC recognized breeds. In addition to grooming, students learn practical business skills, including customer relations, bookkeeping, ")]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("budgeting, and business plan development. Students also get a chance to work in local grooming salons to gain practical experience.")])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Groomer’s Assistant—6 weeks"), _c('br'), _vm._v("Professional Career—14 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Groomer’s Assistant—$1,500"), _c('br'), _vm._v("Professional Career—$2,800")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("North Jersey School of Dog Grooming")]), _c('br'), _vm._v("William Pitt Townsquare"), _c('br'), _vm._v("11 Roosevelt Avenue"), _c('br'), _vm._v("Chatham, NJ 07928"), _c('br'), _vm._v("(201) 635-0101")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The school offers training in professional dog and cat grooming. Students learn fashionable and practical grooming techniques for all breeds of cats and dogs through daily hands-on practice grooming dogs in the school’s professional grooming salon. The school also provides classes on the business aspects of running a grooming salon, such as setting up shop, retail merchandising, mobile grooming vans, equipment and maintenance, record keeping, advertising, and insurance.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("12 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$4,880")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("A payment plan is available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Jersey Shore School of Dog ’N’ Cat Grooming")]), _c('br'), _vm._v("465 B Route 9"), _c('br'), _vm._v("Waretown, NJ 08758"), _c('br'), _vm._v("(609) 971-7000")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The school offers a Professional Pet Groomer course. Students learn dog and cat grooming, basic hygiene, creative hand scissoring, pet anatomy, proper handling techniques, professional equipment care and maintenance, and basic customer relations.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("1 month")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$3,500")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Payment plans are available.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('strong', [_vm._v("Rochester Institute of Dog Grooming")]), _c('br'), _vm._v("2070 East Henrietta Road"), _c('br'), _vm._v("Rochester, NY 14623"), _c('br'), _vm._v("(716) 359-9710")])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The institute offers a course in All-Breed Dog Grooming and Shop Management. Students learn basic combing, brushing, dematting, bathing, drying, nail clipping, and ear-cleaning skills. Other courses include working with poodles, sporting breeds, long-coated breeds, terriers, and cats, shop sanitation, nutrition, anatomy, first aid, and eye care. Skills taught include clipping and scissoring of various styles and patterns, using thinning shears, coat care, and handling. The school also teaches shop management and marketing techniques.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("450 hours in 15 or 29 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$4,600")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Payment plans are available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Tara Lara Academy of K-9 Hair Design")]), _c('br'), _vm._v("16037 Southeast McLoughlin Boulevard"), _c('br'), _vm._v("Portland, OR 97267"), _c('br'), _vm._v("(503) 653-7134")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The academy offers three levels of basic training: Pet Grooming, Pet Stylist, and Pet Care Specialist. The Pet Grooming program prepares students for employment in a grooming salon. Instruction includes equipment use and care, anatomy, handling and control, grooming short-hair and undercoated breeds, ear and gland care, clipping toenails, poodle clipping, dematting coats, and clipping and scissor finishing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Pet Stylist program also prepares students for employment in a grooming salon, but includes more advanced techniques, such as hand scissoring longer clips, cat grooming, hand stripping coarse-coated terriers and other breeds with wire coats, mastering scissoring, and mixing shampoos.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Pet Care Specialist program enables students to manage or own their own styling salon. In addition to all the skills taught in the first two courses, this course teaches massage techniques, shop management, retailing, and admitting and releasing pets.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("Two advanced courses—Pet Care Professional training, which is for ")]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("salon owners only, and the Instructor Program, which requires two years of pet-styling experience—are also offered.")])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Pet Groomer—10 weeks"), _c('br'), _vm._v("Pet Stylist—16 weeks"), _c('br'), _vm._v("Pet Care Specialist—20 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Pet Groomer—$3,075"), _c('br'), _vm._v("Pet Stylist—$4,383"), _c('br'), _vm._v("Pet Care Specialist—$5,755")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Students can house their own cat or dog for $15 per week.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Pennsylvania Academy of Pet Grooming")]), _c('br'), _vm._v("2860 Route 422 West"), _c('br'), _vm._v("Indiana, PA 15701"), _c('br'), _vm._v("(724) 463-6101"), _c('br'), _vm._v("Fax: (724) 349-0237")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The Pennsylvania Academy offers three training programs: Bather/Brusher Grooming, Basic Professional All-Breed Grooming, and Master All-Breed Grooming. The Bather/Brusher Grooming program prepares the student for employment as a bather/brusher in a professional grooming establishment. It includes study of first aid, internal and external parasites, skin disorders, anatomy, types of coats, clarifying texture, dematting, introduction to grooming, and feline and canine bathing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Basic Professional All-Breed Grooming program prepares the student to work as a professional pet groomer. Courses include all of the above plus lessons in grooming cats, toy dogs, nonsporting dogs, herding dogs, sporting dogs, hound dogs, terriers, and working dogs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Master All-Breed Grooming program prepares students to work as professional groomers, salon managers, or salon owners. It gives them the opportunity to refine scissoring skills, increase speed, and learn advanced grooming techniques and covers client-groomer relations, groomer-veterinarian relations, telephone business techniques, record keeping, advertising, retail merchandising, and professionalism.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Bather/Brusher—2 weeks"), _c('br'), _vm._v("Basic Professional—8 weeks"), _c('br'), _vm._v("Master All-Breed—15 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('em', [_vm._v("What it costs:")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Bather/Brusher—$1,450"), _c('br'), _vm._v("Basic Professional—$4,425"), _c('br'), _vm._v("Master All-Breed—$6,755")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("The Pampered Pet School of Dog Grooming")]), _c('br'), _vm._v("DeWalt Professional Building"), _c('br'), _vm._v("109 DeWalt Avenue"), _c('br'), _vm._v("Pittsburgh, PA 15227"), _c('br'), _vm._v("(412) 881-9545"), _c('br'), _vm._v("(412) 881-4744")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The Pampered Pet offers two training programs: Basic Training and Management Training. The Basic Training program is designed to give students hands-on experience working in a grooming shop. The curriculum includes handling and bathing, shampoos, skin treatments, parasites, nails and ears, tools and equipment, combing, brushing, dematting, clipping, scissoring, cat grooming, basic shop keeping, and on-the-job training.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Management Training program includes all the information presented in the Basic Training program plus advanced grooming techniques and business management skills. Courses include customer relations, suppliers, extra-income tactics, handling competition, record keeping, telephone strategies, and retail merchandising.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Basic Training—10 weeks"), _c('br'), _vm._v("Management Training—15 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Basic Training—$4,000"), _c('br'), _vm._v("Management Training—$5,300")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("The Southern Institute of Pet Grooming")]), _c('br'), _vm._v("510 West Main Street"), _c('br'), _vm._v("P.O. Box 313"), _c('br'), _vm._v("Central, SC 29630"), _c('br'), _vm._v("(864) 639-6872")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("The institute offers an All-Breed Career Specialist course, which prepares students for employment in pet salons, kennels, and mobile grooming businesses. Students are also taught how to start, operate, and manage their own grooming businesses. The curriculum includes the ")]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("basics of grooming and equipment, sequence directional styling, scissoring skills and exercises, AKC breeds, anatomy, handling problem animals, skin problems and parasites, first aid, record keeping, retail sales, shop management, and all-breed styling. The institute also offers labs in feline grooming, hand-stripping techniques, and pet tattoos for identification.")])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("12 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$3,300")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("South Carolina School of Dog Grooming")]), _c('br'), _vm._v("P.O. Box 1353"), _c('br'), _vm._v("Irmo, SC 29063"), _c('br'), _vm._v("(803) 781-6598")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The South Carolina School of Dog Grooming offers three training courses: Preparatory Grooming, Extensive Grooming, and Extensive Grooming Plus. The Preparatory Grooming course trains students for entry-level grooming positions. The curriculum includes bathing, dipping, fluff and cage drying, clipping nails, basic anatomy, and clipper operation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Extensive Grooming course trains students to work as certified professional groomers. It covers all 136 breeds, anatomy, nutrition, breeding, dog talk, blade sharpening, health care, hand scissoring, and grooming.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Extensive Grooming Plus course is for students who want to start their own grooming businesses. Students learn to improve technique, quality, and speed—by the end of the course they are able to groom six dogs a day.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Preparatory Grooming—6 weeks"), _c('br'), _vm._v("Extensive Grooming—10 weeks"), _c('br'), _vm._v("Extensive Grooming Plus—13 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Preparatory Grooming—$2,000"), _c('br'), _vm._v("Extensive Grooming—$3,475"), _c('br'), _vm._v("Extensive Grooming Plus—$4,500")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Credit cards are accepted.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('strong', [_vm._v("Texas Allbreed Grooming School")]), _c('br'), _vm._v("1003 Enterprise Place, Suite 100"), _c('br'), _vm._v("Arlington, TX 76001"), _c('br'), _vm._v("(817) 472-7054")])]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Texas Allbreed offers a dog-grooming training course that consists of six sections: Dog Grooming Equipment, Dog Psychology, Dog Grooming Biology, Dog Breed Recognition, Client Relations, and Dog Grooming. Dog Grooming Equipment trains students to use clippers, brushes, combs, rakes, mat splitters, shampoos, dips, rinses, and oils. Dog Psychology teaches how to create a safe environment, recognize potentially dangerous dogs, communicate with dogs, and introduce puppies to grooming. Dog Grooming Biology covers anatomy, skeletal system, exterior confirmation points, respiratory complications, allergies, heartworm diseases, and ear problems. Dog Breed Recognition introduces students to dogs in the AKC’s Toy Group, Sporting Group, Terrier Group, Working Group, Herding Group, Non-Sporting Group, and Hound Group. Client Relations teaches students how to keep clients informed, interpret grooming instructions, suggest appropriate types of grooming, and use proper record keeping and phone techniques. And Dog Grooming, which constitutes 90 percent of the program, teaches roughing, bathing, drying, brushing, dematting, clipping, skimming and thinning, hand stripping, grooming patterns, and perfecting scissoring skills.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("12 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$4,500")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Texas Institute of Pet Design")]), _c('br'), _vm._v("8617 North New Braunfels"), _c('br'), _vm._v("San Antonio, TX 78217"), _c('br'), _vm._v("(210) 822-9355")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("The institute offers three basic training programs: Apprentice Pet Stylist, DermaTech Specialist, and Petcare Hygienist. The Apprentice Pet Stylist program is the most comprehensive program, teaching about pet styling equipment, the mechanics and art of pet styling, speed trimming techniques, and shop management and human relations. The program also includes the entire curriculum of the DermaTech program, which focuses on bathing, drying, and topical conditioning of canine and feline skin and coats. Courses include breed identification, anatomy ")]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("and health, ectoparasites, and finishing techniques. The Petcare Hygienist program prepares students for a supervised position in a grooming salon, providing bathing, drying, and finishing services to dogs and cats.")])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Apprentice Pet Stylist—9 weeks"), _c('br'), _vm._v("DermaTech Specialist—4 weeks"), _c('br'), _vm._v("Petcare Hygienist—4 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Apprentice Pet Stylist—$2,770"), _c('br'), _vm._v("DermaTech Specialist—$1,606"), _c('br'), _vm._v("Petcare Hygienist—$962")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Canine Clippers School of Pet Grooming")]), _c('br'), _vm._v("264 South Fraley Boulevard"), _c('br'), _vm._v("P.O. Box 207"), _c('br'), _vm._v("Dumfries, VA 22026"), _c('br'), _vm._v("(703) 221-3647"), _c('br'), _vm._v("(703) 221-2107")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Canine Clippers offers a professional training in pet grooming. Subjects taught include AKC breed information, dog terminology, first aid, equipment selection, diseases, parasites and sanitation, grooming skills, shop management, dog psychology, anatomy, skin disorders, nutrition, public relations, brushing, combing, dematting, and cat grooming. Specific instruction includes how to use a Clipper Vac System, eliminate internal and external parasites, clean ears, eyes, teeth, and feet, and use kennel management software. Students also learn management principles for operating their own grooming business.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("15 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$5,900")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Credit cards are accepted.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('strong', [_vm._v("Maser’s Academy of Fine Grooming")]), _c('br'), _vm._v("P.O. Box 82344"), _c('br'), _vm._v("Kenmore, WA 98028"), _c('br'), _vm._v("(425) 486-1299"), _c('br'), _vm._v("(425) 334-2309"), _c('br'), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://Denise425@juno.com",
      "target": "_blank"
    }
  }, [_vm._v("Denise425@juno.com")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("The academy offers a Professional Pet Groomer course designed to prepare students for employment in the field of dog and cat grooming. The training focuses on teaching the practical skills needed to work on all the popular breeds that regularly visit pet salons. The curriculum includes bathing, drying, nail trimming, general health problems, scissoring, thinning and stripping, and breed studies. Maser’s Academy also offers an extended learning course for groomers already working in the field who feel they need additional or advanced training.")])]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("70 days")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$2,750")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Wisconsin School of Professional Pet Grooming")]), _c('br'), _vm._v("P.O. Box 175"), _c('br'), _vm._v("Okauchee, WI 53069"), _c('br'), _vm._v("(414) 569-9492"), _c('br'), _vm._v("Fax: (414) 569-1842")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The Wisconsin School offers two courses that train Assistant Stylists and Professional Stylists. The Assistant Stylist course includes classes in sanitation, anatomy, breed identification, behavior and handling, parasites, diseases, nutrition, first aid and CPR, scissored grooming, reproduction and reproductive problems, immunization, and grooming patterns. Upon completion of the program, each student will have groomed approximately sixty dogs, including a minimum of ten brushable breeds and ten mixed and modified breeds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Professional Stylist program includes all of the above plus geriatric care, cat grooming, advanced scissoring, and business skills such as client relations, retailing, record keeping, and pricing. In the Professional program, students groom approximately 125 dogs, including a minimum of twenty brushable breeds, twenty mixed and modified breeds, twenty scissored breeds, twenty spaniels, and twenty terriers. The school also offers workshops in business start-ups, creating a business plan, preparing cash-flow statements, and strategic marketing techniques.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Assistant Stylist—8 weeks"), _c('br'), _vm._v("Professional Stylist—16 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Assistant Stylist—$3,100"), _c('br'), _vm._v("Professional Stylist—$5,700")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The school offers financial advice about funding your education.")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_84"
    }
  }), _c('a', {
    attrs: {
      "id": "ch4-5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("Therapeutic Riding Instruction "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Therapeutic riding instructors offer hippotherapy—also known as equine therapy—services to clients with autism, Down syndrome, spinal bifida, and many other physical, emotional, and developmental disabilities. Instructors help clients experience the benefits of horseback riding. These benefits are both physical and emotional: clients may develop improved posture and balance, increase strength, overcome fear, build self-esteem, and deepen cognitive and social skills. All of these programs are approved by the North American Riding for the Handicapped Association (NARHA) and prepare students for the registered instructor exam—for more information about therapeutic riding, contact NARHA at (800) 369-7433 or P.O. Box 33150, Denver, CO 80233.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Fran Joswick Therapeutic Riding Center")]), _c('br'), _vm._v("26284 Oso Road"), _c('br'), _vm._v("San Juan Capistrano, CA 92675"), _c('br'), _vm._v("(714) 240-8441")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The center trains Therapeutic Riding Instructors. The training begins with instruction in human anatomy, physiology, kinesiology, psychology, growth, and development. Students then study disability definitions, characteristics, and management, precautions and contraindications, lesson plans and structure, teaching techniques, and student assessment and documentation. Students also learn mounting and dismounting techniques, exercises, games and activities, therapy horse selection, volunteer training and management, riding center administration, safe operating procedures, and fund-raising and public relations. Participants are given the opportunity to teach riders with physical, cognitive, sensory, psychosocial, and speech/language impairments.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("5 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$1,700")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Cost includes housing.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_c('strong', [_vm._v("High Hopes Therapeutic Riding")]), _c('br'), _vm._v("36 Town Woods Road"), _c('br'), _vm._v("P.O. Box 254"), _c('br'), _vm._v("Old Lyme, CT 06371"), _c('br'), _vm._v("(860) 434-1974"), _c('br'), _vm._v("Fax: (860) 434-3723")])]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("High Hopes offers a Therapeutic Riding Instructor Training course designed to prepare students to plan and implement safe and effective therapeutic riding classes. The curriculum includes equine movement analysis, anatomy of the rider, postural alignment and corrections, medical terminology, body mechanics of mounting and dismounting, rider assessment, precautions and contraindications, physical disabilities, neurological impairments, and orthopedic impairments. Students also learn therapy horse selection and evaluation, tack and equipment management, teaching techniques and strategies, lesson planning, and how to work with people with psychosocial issues, visual, and speech/language impairments. And that’s only the first half of the training—the other half is spent in an individually designed practicum project. Prerequisites for this program include current CPR and first aid certification, previous riding experience, and a minimum of ten hours’ experience teaching riding skills.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("6 months")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$1,300")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Equest Center for Therapeutic Riding")]), _c('br'), _vm._v("3800 Troy Road"), _c('br'), _vm._v("Wylie, TX 75098"), _c('br'), _vm._v("(972) 412-1099")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Equest offers a Therapeutic Riding Instructor Training course. The curriculum includes human anatomy and kinesiology, human psychology, teaching skills and approaches, disabilities, mounting and dismounting procedures, equipment selection and adaptation, volunteer management, selecting and handling therapy horses, hippotherapy, practice teaching, and augmentative communication. Prerequisites include some knowledge of stable management, good riding skills, and current first aid/CPR certification (in which students can be trained on campus).")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('em', [_vm._v("How long it takes:")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("5 weeks")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$1,695")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Cost includes housing.")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }), _c('a', {
    attrs: {
      "id": "ch4-6"
    }
  }, [_vm._v("Miscellaneous Animals "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "ch4-6"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are three careers in this section: animal communication, pet sitting, and exotic animal management. The animal communication program teaches telepathic communication and healing both to help animals recover quickly from pain, illness, and surgery, and also to help them express the unmet needs that may be resulting in problem behaviors. The pet-sitting programs offer training, support, and certification to people interested in becoming professional pet sitters. And the exotic animal management program teaches students to work with exotic animals—handling, feeding, and caring for them—in zoos. If you’re interested in a degree program in zookeeping, call or write the American Association of Zoo Keepers, Inc., at 635 Southwest Gage Boulevard, Topeka, KS 66606 or (800) 468-1966.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Exotic Animal Training and Management Program")]), _c('br'), _vm._v("America’s Teaching Zoo"), _c('br'), _vm._v("Moorpark College"), _c('br'), _vm._v("7075 Campus Road"), _c('br'), _vm._v("Moorpark, CA 93021"), _c('br'), _vm._v("(805) 378-1400")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "ch4-6"
    }
  }, [_vm._v("America’s Teaching Zoo offers a certificate program in Exotic Animal Training and Management, which prepares students to work in zoos. The program combines lectures and classes with daily hands-on work at America’s Teaching Zoo. Students are responsible for cleaning cages, feeding animals, preparing diets, checking on the animal collection, and killing rodents, pigeons, and rabbits to provide fresh meat for some of the animals. Students also build and repair cages, night boxes, fences, equipment, and training props. Because of the potential of some of the animals to do serious injury, discipline in the program is strict. During the first year of study, students are not allowed to interact with the animals without specific instructions from a supervisor. Many of the ")]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("animals are being trained, and outside contact can hinder the training process. In addition to working at America’s Teaching Zoo, students are offered opportunities to work at the Los Angeles and Santa Barbara zoos.")])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("2 years")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("California residents—$10,000"), _c('br'), _vm._v("Out-of-state students—$14,000")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Financial aid is available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Paws and Claws")]), _c('br'), _vm._v("614 Rudd Road"), _c('br'), _vm._v("Vista, CA 92084"), _c('br'), _vm._v("(760) 630-0777")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Paws and Claws offers a training program in interspecies communication. The program consists of two courses—a Basic Workshop and Advanced Training—which teach students how to get in touch with the soul or spirit of animals, their thoughts, values, perceptions, and understanding. In the Basic Workshop, students learn meditation techniques and exercises to help increase their awareness and understanding of animals and become more receptive to telepathic communication. In the Advanced Training, students hone their skills and learn to overcome the inhibitions that block communication with animals. They study the use of shamanic journeying for power animal guidance, the use of mantric sounds of the Mayan language, and they are introduced to the use of color and light therapy in healing ethereal subtle bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Graduates of the Advanced Training can offer their services as animal communications specialists, helping pets and their owners cope with problem behaviors that are often the result of unmet needs or physical or emotional trauma.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Basic Workshop—2 days"), _c('br'), _vm._v("Advanced Training—3 days")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Basic Workshop—$ 150"), _c('br'), _vm._v("Advanced Training—$400")])])])])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_c('strong', [_vm._v("National Association of Professional Pet Sitters")]), _c('br'), _vm._v("1200 G Street, N.W., Suite 760"), _c('br'), _vm._v("Washington, DC 20005"), _c('br'), _vm._v("(202) 393-3317"), _c('br'), _vm._v("Fax: (202) 393-0336"), _c('br'), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.petsitters.org",
      "target": "_blank"
    }
  }, [_vm._v("www.petsitters.org")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The association offers a correspondence certification program in Pet Sitting. The training includes a course of study in business management, animal care, and health issues. It also includes viewing the video "), _c('em', [_vm._v("Pet Sitting: Getting Started")]), _vm._v(", and reading the "), _c('em', [_vm._v("Cat Owner’s Home Veterinary Handbook")]), _vm._v(" and the Dog "), _c('em', [_vm._v("Owner’s Home Veterinary Handbook")]), _vm._v(". Pet sitters certified through NAPPS benefit from a referral network (including a nationwide 800 number), a Mentor Program for novice sitters, and the availability of liability and bonding insurance.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("90 days")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("$205")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Credit cards are accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Pet Sitters International")]), _c('br'), _vm._v("418 East King Street"), _c('br'), _vm._v("King, NC 27021-9163"), _c('br'), _vm._v("(910) 983-9222"), _c('br'), _vm._v("Fax: (910) 983-3755"), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://petsitin@ols.net",
      "target": "_blank"
    }
  }, [_vm._v("petsitin@ols.net")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Pet Sitters International offers three correspondence training courses in pet sitting: Pet Sitting Technician, Advanced Pet Sitting Technician, and Pet Sitting Professional. The Pet Sitting Technician course includes basic psychological principles of animal intelligence and behavior, proper handling and restraint techniques, animal first aid (including bandaging and dressing wounds), sanitation, flea control, care of older animals, and information about dog, cat, and horse breeds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Advanced Pet Sitting Technician course offers additional training in nutrition, emergency veterinary care, and advanced animal assisting (which includes maternal care, vaccinations, labor and delivery, and newborn animal care). Students also learn to recognize common signs of disease in cats, dogs, horses, cattle, sheep, goats, swine, and birds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("The Pet Sitting Professional course emphasizes practical business information, helping pet sitters sharpen their knowledge, skills, and competitive edge. Membership in Pet Sitters International is a prerequisite for all of the courses.")])]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("How long it takes:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Pet Sitting Technician—3 to 6 months"), _c('br'), _vm._v("Advanced Pet Sitting Technician—1 to 3 months"), _c('br'), _vm._v("Pet Sitting Professional—6 months to 2 years")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("What it costs:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Membership fee—$75"), _c('br'), _vm._v("Pet Sitting Technician—$399"), _c('br'), _vm._v("Advanced Pet Sitting Technician—$179"), _c('br'), _vm._v("Pet Sitting Professional—Varies")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Credit cards are accepted.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a3386e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter04.vue
// module id = 105
// module chunks = 0